import {
  Modal,
  Text,
  ViewStyle,
  TextStyle,
  View,
} from 'react-native';
import React from 'react';
import {Button} from 'ui-kits';
import {spacing, corner_radius} from 'theme/Units';
import colors from 'theme/Colors';

export type ConfirmModalProps = Readonly<{
  onClose: () => void;
  onConfirm: () => void;
  header: string;
  message: string;
  visible: boolean;
  cancelButtonText?: string;
  confirmButtonText?: string;
}>;
export function ConfirmModal(props: ConfirmModalProps): JSX.Element {
  const {
    header,
    onClose,
    onConfirm,
    visible,
    message,
    cancelButtonText,
    confirmButtonText,
  } = props;

  function handleConfirm(){
    onConfirm();
    onClose();
  }

  return (
    <Modal
      animationType="none"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}>
      <View style={styles.modalContainer}>
        <View style={styles.modalContent}>
          {header ? <Text style={styles.header}>{header}</Text> : null}
          <Text style={styles.message}>{message}</Text>
          <View style={styles.buttonsWrapper}>
            <Button
              onPress={onClose}
              text={cancelButtonText}
              style={styles.actionButton}
              variant="secondary"
            />
            <Button onPress={handleConfirm} text={confirmButtonText} style={styles.actionButton} />
          </View>
        </View>
      </View>
    </Modal>
  );
}

type styleType = {
  modalContainer: ViewStyle;
  modalContent: ViewStyle;
  message: TextStyle;
  buttonsWrapper: ViewStyle;
  actionButton: ViewStyle;
  header: TextStyle;
};
const styles: styleType = {
  header: {
    fontSize: 26,
    fontWeight: '500',
    color: colors.palette.secondaryBlack5,
  },
  buttonsWrapper: {
    flexDirection: 'row',
    gap: spacing['4'],
    // border: '1px solid black',
    width: '100%',
  },
  actionButton: {
    width: '100%',
    flex: 0.5,
    minWidth: 100,
  },
  modalContainer: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: spacing['8'],
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: colors.palette.white,
    alignItems: 'center',
    padding: spacing['8'],
    borderRadius: corner_radius['rounded-lg'],
    overflowY: 'auto',
    gap: spacing['4'],
    boxSizing: 'border-box',
    maxWidth: 500,
  },
  message: {
    fontSize: 20,
    fontWeight: '500',
    color: colors.palette.secondaryBlack5,
    textAlign: 'center',
  },
};
